import { render, staticRenderFns } from "./GeneralItemRegistDialog.vue?vue&type=template&id=80b5001e&scoped=true&"
import script from "./GeneralItemRegistDialog.vue?vue&type=script&lang=js&"
export * from "./GeneralItemRegistDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b5001e",
  null
  
)

export default component.exports